import {
  JW_PLAYER_URL_REGEX,
  VIMEO_URL_REGEX,
  YOUTUBE_URL_REGEX,
} from "@/modules/companies/client/components/Media/constants"

export const isVideoUrlValid = (videoUrl?: string | null): boolean => {
  return (
    !!videoUrl &&
    (YOUTUBE_URL_REGEX.test(videoUrl) || VIMEO_URL_REGEX.test(videoUrl) || JW_PLAYER_URL_REGEX.test(videoUrl))
  )
}
